import { PointsModalForm } from "./PointsModalForm"

const PointsModalFormWrapper = ({
  user,
  setOpenPointsModal,
  pointsHistory,
  page,
  pageSize,
  setPage,
  setPageSize,
  total,
  isLoading,
  haveAccess,
  currentUser
}) => {

  if (user) {
    return (
      <PointsModalForm
        user={user}
        setOpenPointsModal={setOpenPointsModal}
        pointsHistory={pointsHistory}
        haveAccess={haveAccess}
        currentUser={currentUser}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        total={total}
        isLoading={isLoading}
      />
    );
  }
  return null;
};

export { PointsModalFormWrapper };
